module.exports = __webpack_public_path__ + "static/media/marilyns-windows-logo.a72bb2fa.png";